export default __webpack_public_path__ + "static/media/edu.7b85a9ab.svg";